import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import { useAuth0 } from '@auth0/auth0-react';
import ListaArticoliAreaproblemiDBS from './pezziDB/ListaArticoliAreaproblemiDBS';
import SchedaProdotto from '../../SchedaProdotto';
import SubHeaderAggiorna from '../../navigadbsections/navigaDBsubMenu/SubHeaderAggiorna';


function DBperAreaproblemiDB({product, setProductFunction, utente, charCount, setCharCount, setTradPermessa, tradPermessa}) {


     const { user, getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState(""); 
    const [listaArticoli, setlistaArticoli] = useState([]);
    /* const [anteprimaProdotto, setAnteprimaProdotto] = useState("no data"); */

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/prodotti/get/getProductsWithHTMLinTitle/", {headers: {Authorization: "Bearer "+token}}) 
          .then(resp => resp.json())
          .then(data => setlistaArticoli(data)) 
      }, [ token ]);


     useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);


    const aggiorna = function() {
      if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    fetch(apiUrl + "/prodotti/get/getProductsWithHTMLinTitle/", {headers: {Authorization: "Bearer "+token}}) 
      .then(resp => resp.json())
      .then(data => setlistaArticoli(data)) 
    }

    return (
        <div class="center">
          <div className='subHeader'>
                <SubHeaderAggiorna 
                  titolo="Articoli con codice html nel titolo"
                  funzAggiorna={aggiorna}
                />
            </div>
            <div class="cf contentSubSubHeader flex">
                <div class="fl-ns w-100 pr1 pl1 sfondoBiancoTema">
                    <ListaArticoliAreaproblemiDBS
                        setProductFunction={setProductFunction}
                        listaArticoli={listaArticoli}
                        utente={utente}
                        /* setAnteprimaProdotto={setAnteprimaProdotto} */
                        tradPermessa={tradPermessa}
                    />
                </div>
                {/* <div className='w-100 w-30-ns sfondoBiancoTema'>
                    {anteprimaProdotto !== "no data" && <SchedaProdotto className="" prodotto={anteprimaProdotto} lang="it" html={false} />}
                </div> */}
            </div>
        </div>

    )
}


export default DBperAreaproblemiDB;
